

export enum KalturaCaptionType {
    cap = '4',
	dfxp = '2',
	scc = '5',
	srt = '1',
	webvtt = '3'
}